























import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import CLiveIndicator from '@/components/CLiveIndicator/CLiveIndicator.vue'
import CFlagIcon from '@/components/CFlagIcon/CFlagIcon.vue'
import { EventTypes } from '@altenar/models'

const componentName: string = 'CEventsTableRowPrefix'
@Component({
  name: `${componentName}`,
  components: { CFlagIcon, CLiveIndicator }
})
export default class UiComponent extends Mixins() {
  @Prop({ default: {} }) public event!: EventTypes.Event
  get startTime() {
    const d = this.event.Date
    const startTime = ('0' + d.getDate()).slice(-2) + '.' +
               ('0' + (d.getMonth() + 1)).slice(-2) + ' / ' +
               ('0' + d.getHours()).slice(-2) + ':' +
               ('0' + d.getMinutes()).slice(-2)
    return startTime
  }
}
Vue.component(componentName, UiComponent)
